import React, { ReactElement, useEffect } from "react";
import Modal from "../../../shared/components/modal/Modal";
import { connect, FormikContextType } from "formik";
import OpbrengstItemComponent from "./opbrengstitem-component";
import { DevDebug } from "../../../shared/components/dev-debug/dev-debug";
import { FinancieringsbehoefteState } from "../../infra/financieringsbehoefte-types";

type NettoVerkoopopbrengstProps = {
  closeModal?: () => void;
};

const NettoVerkoopopbrengstComponent = ({
  closeModal,
  formik
}: NettoVerkoopopbrengstProps & {
  formik: FormikContextType<FinancieringsbehoefteState>;
}): ReactElement => {
  useEffect(() => {
    const handleKeyDown = (event: { key: string }): void => {
      /* istanbul ignore next */
      if (event.key === "Escape") {
        if (closeModal) {
          closeModal();
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [closeModal]);

  const nettoOpbrengstPanden = formik.values.nettoPandOpbrengst;
  const body = (
    <>
      {nettoOpbrengstPanden.map(
        (item): ReactElement => {
          const index = nettoOpbrengstPanden.indexOf(item);
          return <OpbrengstItemComponent item={item} index={index} key={index} />;
        }
      )}

      <DevDebug />
    </>
  );
  return (
    <>
      <Modal
        title="Netto verkoopopbrengst"
        body={body}
        noEditableData={true}
        onCancelClick={closeModal}
        isFormDirty={formik.dirty}
      />
    </>
  );
};

export default connect<{}, FinancieringsbehoefteState>(NettoVerkoopopbrengstComponent);
